import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";

export default function ReturnBlock(props: any) {

    let {userPermissions} = useContext(AuthContext)

    const {returnObj, setReturnObj} = props

    // Actions on Pieces returned from the Mapping Block
    const actionsList = ['None', 'Join', 'Sum', 'Transform']
    const actionElements = actionsList.map(item => {
        return <option key={actionsList.indexOf(item)} value={item.toLowerCase()}>{item}</option>
    })

    // Delimiter is shown only IF action == JOIN
    const delimiters = ["", " ; ", " , ", " . ", " | ", " x ", " - "]
    const delimiterElements = delimiters.map(item => {
        return <option key={delimiters.indexOf(item)} value={item}>{item}</option>
    })

    const [actionsClass, setActionsclass] = useState<any>('trgval-return-actions')


    function handleChange(event: any) {

        const {name, value} = event.target
        // console.log(name, value)

        if (name === 'action') {
            setReturnObj((prev: any) => {return {...prev, actionType: value}})

            if (value !== 'join') {
                setReturnObj((prev: any) => {return {...prev, joinDelim: ''}})
            }

            if (value !== 'transform') {
                setReturnObj((prev: any) => {return {...prev, transformRules: ''}})
            }

            if (value === 'transform') {
                setActionsclass('trgval-return-actions trgval-return-actions-transform')
            } else {
                setActionsclass('trgval-return-actions')
            }
        }

        if (name === 'return') {
            setReturnObj((prevState: any) => {
                return {...prevState, returnType: value, returnIfCond: value === 'default' ? '' : prevState.returnIfCond}
            })
        }

        if (name === 'delimiter') {
            setReturnObj((prevState: any) => {
                return {...prevState, joinDelim: value, transformRules: ''}
            })
        }

        if (name === 'transform_rules') {
            setReturnObj((prevState: any) => {
                return {...prevState, transformRules: value, joinDelim: ''}
            })
        }

        if (name === 'returnIF_condition') {
            setReturnObj((prevState: any) => {
                return {...prevState, returnIfCond: value}
            })

        }
    }

    return (

        <div className="trgval-return-container">

            <div className="trgval-return-subcont">

                <div className={actionsClass}>

                    <div className="field-label">Final Actions:</div>
                    <select
                        id="action"
                        name="action"
                        value={returnObj.actionType}
                        onChange={handleChange}
                        disabled={!userPermissions.canEdit}
                    >
                        {actionElements}
                    </select>

                    {/* Delimiter */}
                    {returnObj.actionType === 'join' &&
                        <>
                            <div className="field-label">delimiter:</div>
                            <select
                                id="delimiter"
                                name="delimiter"
                                onChange={handleChange}
                                value={returnObj.joinDelim}
                                disabled={!userPermissions.canEdit}
                            >
                                {delimiterElements}
                            </select>
                        </>
                    }

                    {/* Transformations */}
                    {returnObj.actionType === 'transform' &&
                        <>
                            <div className="field-label">rules:</div>
                            <input
                                id="transform-rules"
                                name="transform_rules"
                                className="regular-input"
                                placeholder="split|x|1| && remove|Intel|"
                                onChange={handleChange}
                                value={returnObj.transformRules}
                                disabled={!userPermissions.canEdit}
                            />
                        </>
                    }

                </div>

                <div className="trgval-return-type">

                    <div className="field-label"><span className="bold">&&</span></div>
                    <select
                        id="return"
                        name="return"
                        value={returnObj.returnType}
                        onChange={handleChange}
                        disabled={!userPermissions.canEdit}
                    >
                        <option value="default">return default</option>
                        <option value="returnIF">return if</option>
                    </select>

                    {returnObj.returnType === 'returnIF' &&
                        <input
                            id="return-condition"
                            name="returnIF_condition"
                            className="regular-input"
                            placeholder=">= 8"
                            onChange={handleChange}
                            value={returnObj.returnIfCond}
                            disabled={!userPermissions.canEdit}
                        />
                    }
                </div>

            </div>

        </div>

    )
}